import { Link } from 'react-router-dom';
import FooterLogo from '@/components/FooterLogo';

export default function Footer() {
  return (
    <footer id="contact" className="relative bg-background-300 text-white border-t border-white/10 overflow-hidden scroll-mt-24">
      {/* Subtle warm purple gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/25 via-transparent to-primary-950/20 pointer-events-none" />
      <div className="absolute inset-0 tech-grid tech-grid-mask opacity-40 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 items-end">
          <div className="md:col-span-2">
            <FooterLogo className="h-[142.5px] w-auto -mt-9" />
          </div>

          <div className="md:col-span-10 justify-self-end space-y-4 text-left">
            <div>
              <div className="text-xs font-mono uppercase text-white/40 mb-3 tracking-widest glow-text">Explore</div>
              <ul className="space-y-2.5 text-sm">
                <li><Link to="/investing" className="text-white/80 hover:text-white transition-colors">Investing</Link></li>
                <li><Link to="/building" className="text-white/80 hover:text-white transition-colors">Services</Link></li>
              </ul>
            </div>
            <div>
              <ul className="space-y-2.5 text-sm">
                <li>
                  <a href="mailto:contact@libertysoft.sg" className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors break-all">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-mail-line text-sm"></i>
                    </span>
                    contact@libertysoft.sg
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/40 font-mono">
          <div>© {new Date().getFullYear()} Liberty Soft Pte. Ltd. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}